<script setup lang="ts">
    import { IInteractionTranscriptionSegment } from '@/js/services/api/interaction/types';
    import { __ } from '@/js/stores/expressions';
    import TranscriptionSegmentVisualization from './TranscriptionSegmentVisualization.vue';

    defineProps<{
        customerSegments: IInteractionTranscriptionSegment[];
        agentSegments: IInteractionTranscriptionSegment[];
        duration: number;
        currentTime: number;
        hasSentimentData: boolean;
    }>();
</script>

<template>
    <div class="flex items-center gap-3.5 min-w-0">
        <slot name="before" />

        <div
            v-if="hasSentimentData"
            class="grid grid-cols-[auto_1fr] gap-3.5 items-center flex-1 min-w-0"
        >
            <div class="flex flex-col gap-1.5 border-r border-gray-light pr-3.5">
                <span class="h-4 flex items-center justify-end text-overline-sm text-gray-medium">
                    {{ __('customer') }}
                </span>
                <span class="h-4 flex items-center justify-end text-overline-sm text-gray-medium">
                    {{ __('agent') }}
                </span>
            </div>

            <div class="relative flex flex-col gap-1.5 min-w-0">
                <TranscriptionSegmentVisualization
                    :segments="customerSegments"
                    :duration="duration"
                    :current-time="currentTime"
                />
                <TranscriptionSegmentVisualization
                    :segments="agentSegments"
                    :duration="duration"
                    :current-time="currentTime"
                />
                <slot />
            </div>
        </div>

        <div v-else class="relative flex-1 min-w-0 h-4 flex items-center">
            <div class="w-full h-1 rounded-full bg-gray-light" />
            <slot />
        </div>
    </div>
</template>
